import React from "react";
import logo from "./logo.svg";
import "./App.css";
import axios from "axios";
import { resourceLimits } from "worker_threads";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuList from "@mui/material/MenuList";
import makeStyles from "@mui/styles/makeStyles";
import { useTheme } from "@mui/material/";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import QuizIcon from "@mui/icons-material/Quiz";
import Link from "@mui/icons-material/Link";
import Button from "@mui/material/Button";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

function App() {
  const [data, setData] = React.useState<any>();

  // const queryString = require("query-string");

  const [faqContent, setFaqContent] = React.useState<any>(undefined);
  const [display, setDisplay] = React.useState<any>({
    menu: true,
    faq: false,
    contact: false,
  });
  const [category, setCategory] = React.useState<any>("registration");

  const useStyles = makeStyles(() => ({
    faqs: {
      "& p": {
        fontFamily: "Tablet Gothic, sans-serif",
        fontWeight: 600,
        fontSize: "14.222px",
        lineHeight: "27px",
      },
    },
    answer: {
      "& p": {
        fontWeight: "normal",
      },
    },
  }));

  const classes = useStyles();

  React.useEffect(() => {
    // get content from ww2
    const fetchData = async () => {
      const response = await axios.get(
        "https://www.namm.org/jsonapi/node/json_faq?page[limit]=1000"
      );

      const registration: any = [];
      const general: any = [];
      const health: any = [];
      const exhibitor: any = [];
      const nammshowplus: any = [];

      // Filter the faqs into individual arrays for each category.
      // TODO: make this list dynamically
      response.data.data.forEach((element: any) => {
        if (element.attributes.field_json_show_code.length > 0) {
          if (element.attributes.field_json_show_code.includes("wn22-reg")) {
            registration.push(element);
          }
          if (
            element.attributes.field_json_show_code.includes("wn22-general")
          ) {
            general.push(element);
          }
          if (element.attributes.field_json_show_code.includes("wn22-health")) {
            health.push(element);
          }
          if (
            element.attributes.field_json_show_code.includes("wn22-exhibitor")
          ) {
            exhibitor.push(element);
          }
          if (element.attributes.field_json_show_code.includes("wn22-plus")) {
            nammshowplus.push(element);
          }
        }
      });

      registration.sort((a: any, b: any) =>
        a.attributes.field_json_weight < b.attributes.field_json_weight ? -1 : 1
      );

      general.sort((a: any, b: any) =>
        a.attributes.field_json_weight < b.attributes.field_json_weight ? -1 : 1
      );

      health.sort((a: any, b: any) =>
        a.attributes.field_json_weight < b.attributes.field_json_weight ? -1 : 1
      );

      exhibitor.sort((a: any, b: any) =>
        a.attributes.field_json_weight < b.attributes.field_json_weight ? -1 : 1
      );

      nammshowplus.sort((a: any, b: any) =>
        a.attributes.field_json_weight < b.attributes.field_json_weight ? -1 : 1
      );

      setData({ registration, general, health, exhibitor, nammshowplus });
    };

    const queryString = require("query-string");

    // look for query params
    // Grab, parse url query parameters to check for market code or display help
    const urlQueryParameters = queryString.parse(window.location.search);

    if (urlQueryParameters && urlQueryParameters.category) {
      switch (urlQueryParameters.category) {
        case "registration":
          setCategory("registration");
          break;
        case "general":
          setCategory("general");
          break;
        case "exhibitor":
          setCategory("exhibitor");
          break;
        case "health":
          setCategory("health");
          break;
        case "nammshowplus":
          setCategory("nammshowplus");
          break;
      }
    }

    fetchData().catch(console.error);
  }, []);

  // TODO: Move to external Component
  const HelpMenu = () => {
    const options = ["Frequetly Asked Questions"];

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [selectedIndex, setSelectedIndex] = React.useState(1);
    const [open, setOpen] = React.useState(false);

    // const handleClick = () => {
    //     // setSelectedIndex(index);
    //     setAnchorEl(null);
    //     setDisplay({ ...display, faq: true });
    // };

    const handleListKeyDown = (event: React.KeyboardEvent) => {
      if (event.key === "Tab") {
        event.preventDefault();
        setOpen(false);
      } else if (event.key === "Escape") {
        setOpen(false);
      }
    };

    return (
      <Box sx={{ maxWidth: "300px" }}>
        <MenuList
          autoFocusItem={open}
          id="composition-menu"
          aria-labelledby="composition-button"
          onKeyDown={handleListKeyDown}
        >
          <MenuItem
            // disabled={index === 0}
            selected={display.faq}
            onClick={() =>
              setDisplay({ ...display, faq: true, contact: false })
            }
          >
            <LiveHelpIcon />
            &nbsp; Frequently Asked Questions
          </MenuItem>
          <MenuItem
            // disabled={index === 0}
            selected={display.contact}
            onClick={() =>
              setDisplay({ ...display, contact: true, faq: false })
            }
          >
            <ContactPhoneIcon />
            &nbsp; Contact Us
          </MenuItem>
        </MenuList>
      </Box>
    );
  };

  const FrequentlyAskedQuestions = () => {
    const handleCategoryChange = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      setCategory((event.target as HTMLInputElement).value);
    };

    const FaqTypes = () => {
      return (
        <Box sx={{ margin: "20px 0px 20px 0px", textAlign: "center" }}>
          <h1>NAMM Show Frequently Asked Questions</h1>
          <FormControl>
            {/* <FormLabel id="demo-radio-buttons-group-label">Category</FormLabel> */}
            <RadioGroup
              row
              defaultValue="registration"
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              value={category}
              onChange={handleCategoryChange}
            >
              <FormControlLabel
                value="registration"
                control={<Radio />}
                label="Registration"
              />
              <FormControlLabel
                value="general"
                control={<Radio />}
                label="General &amp; On-site"
              />
              <FormControlLabel
                value="exhibitor"
                control={<Radio />}
                label="Exhibitors"
              />
              {/* <FormControlLabel value="exhibitors" control={<Radio />} label="Exhibitors" /> */}
              <FormControlLabel
                value="health"
                control={<Radio />}
                label="Health &amp; Safety"
              />
              <FormControlLabel
                value="nammshowplus"
                control={<Radio />}
                label="NAMM Show+"
              />
            </RadioGroup>
          </FormControl>
        </Box>
      );
    };

    const FaqCategory = () => {
      return (
        <>
          {data &&
            data[category].map((faq: any, index: number) => {
              return (
                <Accordion key={index} className={classes.faqs}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: faq.attributes.field_json_faq_question.value,
                      }}
                      // className={classes.question}
                    />
                  </AccordionSummary>

                  <AccordionDetails>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: faq.attributes.field_json_faq_answer.value,
                      }}
                      className={classes.answer}
                    />
                  </AccordionDetails>
                </Accordion>
              );
            })}
        </>
      );
    };

    return (
      <>
        <FaqTypes />
        <FaqCategory {...data} />
      </>
    );
  };

  const ContactUs = () => {
    return <p>contact us here.</p>;
  };

  return (
    <Container maxWidth="md" sx={{ marginTop: "10px" }}>
      {/* <Typography variant="body2">
          <strong>Welcome to NAMM Show Help!</strong>
      </Typography>
      <Typography variant="body1">Below you will find frequently asked questions and more.</Typography>
      <Divider />
      {display.menu && <HelpMenu />}
      <Divider /> */}
      <Box sx={{ marginTop: "20px" }}>
        <FrequentlyAskedQuestions {...data} />
        {display.contact && <ContactUs />}
      </Box>
    </Container>
  );
}

export default App;
